import { observer } from 'mobx-react';
import { BUTTON_VARIANTS } from '../../../../../../../../components/inputs/button-variants';
import FedexV2RegistrationModalLayout from '../fedex-v2-registration-modal-layout';
import FedexV2RegistrationMfaInputStep from '../steps/fedex-v2-registration-mfa-input-step';
import { IFedexV2RegistrationModalStepProps } from './fedex-v2-registration-modal-step-props';

const FedexV2RegistrationMfaInputModalStep: React.FC<IFedexV2RegistrationModalStepProps> = observer(({
    registration,
    modalVGroup,
}) => {
    const loading = registration.isLoading;

    return (
        <FedexV2RegistrationModalLayout
            registration={registration}
            buttons={[{
                text: 'Verify',
                variant: BUTTON_VARIANTS.Primary,
                onClick: () => {
                    modalVGroup.validate();
                    if (modalVGroup.isValid()) {
                        registration.submitMfa();
                    }
                },
                hasLoader: true,
                isLoading: loading,
            }]}
        >
            <FedexV2RegistrationMfaInputStep mfa={registration.mfa} modalVGroup={modalVGroup} />
        </FedexV2RegistrationModalLayout>
    );
});

export default FedexV2RegistrationMfaInputModalStep;
